/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Shift } from './Shift';
import {
    ShiftFromJSON,
    ShiftFromJSONTyped,
    ShiftToJSON,
    ShiftToJSONTyped,
} from './Shift';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListMissingShiftsResponse
 */
export interface ListMissingShiftsResponse {
    /**
     * 
     * @type {Array<Shift>}
     * @memberof ListMissingShiftsResponse
     */
    data: Array<Shift>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListMissingShiftsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListMissingShiftsResponse interface.
 */
export function instanceOfListMissingShiftsResponse(value: object): value is ListMissingShiftsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListMissingShiftsResponseFromJSON(json: any): ListMissingShiftsResponse {
    return ListMissingShiftsResponseFromJSONTyped(json, false);
}

export function ListMissingShiftsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMissingShiftsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ShiftFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListMissingShiftsResponseToJSON(json: any): ListMissingShiftsResponse {
      return ListMissingShiftsResponseToJSONTyped(json, false);
  }

  export function ListMissingShiftsResponseToJSONTyped(value?: ListMissingShiftsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ShiftToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

